<template lang="pug">
  v-container
    <!--Charts-->
    v-row
      v-col(:cols="12")
        SimulationChart(title="Signals plot")
    v-row
      v-col(:cols="12")
        ChartSettings
</template>
<script>
import SimulationChart from "@/components/SimulationChart/SimulationChart";
import ChartSettings from "@/components/SimulationChart/ChartSettings";

export default {
  components: {
    SimulationChart,
    ChartSettings
  }
};
</script>
<style></style>
